import React, { useMemo, useState } from "react";
import {
  FiChevronLeft,
  FiChevronRight,
  FiFileText,
  FiHelpCircle,
  FiHome,
  FiImage,
  FiLogOut,
  FiPlusSquare,
  FiSettings,
  FiX,
} from "react-icons/fi";
import { IoMdQrScanner } from "react-icons/io";
import { MdContentCopy } from "react-icons/md";
import { toast } from "react-toastify";
import logo from "../image/logo.png";
import "./Sidebar.css";

const Sidebar = ({
  onMenuItemClick,
  activeMenuItem,
  isMobileView = false,
  isMobileOpen = false,
  onRequestCloseMobile,
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const showLabels = isMobileView || isOpen;

  const navItems = useMemo(
    () => [
      { key: "Dashboard", label: "Home", icon: FiHome },
      { key: "CurrentContent", label: "Current Content", icon: FiFileText },
      { key: "Scanner", label: "Scanner", icon: IoMdQrScanner },
      { key: "Generator", label: "Generator", icon: FiPlusSquare },
      { key: "Content", label: "Create Content", icon: MdContentCopy },
      { key: "AddToGallery", label: "Add To Gallery", icon: FiPlusSquare },
      { key: "MyGallery", label: "My Gallery", icon: FiImage },
      { key: "HowItWorksGuide", label: "How It Works", icon: FiHelpCircle },
    ],
    []
  );

  const handleLogout = () => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      window.location.href = "https://www.tattqr.com";
    } catch (error) {
      console.log("error is", error);
      toast.error("Unable to log out right now. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const handleItemClick = (menuKey) => {
    onMenuItemClick(menuKey);
    if (isMobileView && onRequestCloseMobile) {
      onRequestCloseMobile();
    }
  };

  return (
    <aside
      className={[
        "sidebar-shell",
        isOpen ? "open" : "close",
        isMobileView ? "mobile" : "desktop",
        isMobileOpen ? "mobile-open" : "mobile-closed",
      ].join(" ")}
    >
      <div className="sidebar-top">
        <button
          type="button"
          className="sidebar-brand"
          onClick={() => handleItemClick("Dashboard")}
          title="Go to dashboard"
        >
          <img src={logo} alt="TattQR logo" />
        </button>
        {isMobileView ? (
          <button
            type="button"
            className="sidebar-mobile-close"
            onClick={onRequestCloseMobile}
            aria-label="Close menu"
          >
            <FiX />
          </button>
        ) : (
          <button
            type="button"
            className="sidebar-toggle"
            onClick={() => setIsOpen((prev) => !prev)}
            aria-label={isOpen ? "Collapse sidebar" : "Expand sidebar"}
          >
            {isOpen ? <FiChevronLeft /> : <FiChevronRight />}
          </button>
        )}
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeMenuItem === item.key;
          return (
            <button
              key={item.key}
              type="button"
              className={`sidebar-link ${isActive ? "active" : ""}`}
              onClick={() => handleItemClick(item.key)}
              title={item.label}
            >
              <Icon />
              {showLabels && <span>{item.label}</span>}
            </button>
          );
        })}
      </nav>

      <div className="sidebar-bottom">
        <button
          type="button"
          className={`sidebar-link ${activeMenuItem === "Profile" ? "active" : ""}`}
          title="Settings"
          onClick={() => handleItemClick("Profile")}
        >
          <FiSettings />
          {showLabels && <span>Settings</span>}
        </button>
        <button
          type="button"
          className="sidebar-link sidebar-logout"
          onClick={handleLogout}
          title="Log Out"
        >
          <FiLogOut />
          {showLabels && <span>Log Out</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
